import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { colorBackgroundGeneratorSchema } from './../basics/colorSchema.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const VACANCY_LIST_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...colorBackgroundGeneratorSchema('item', 'Item'),
    ...DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'showLocationsFilter',
      label: 'components.vacancyList.schema.showLocationsFilter',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'emptyMessage',
      label: 'components.vacancyList.schema.emptyMessage',
      type: 'text',
      default: ''
    },
    {
      formControlName: 'buttons',
      label: 'components.vacancyList.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
